import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getToken, getUser, roleHome } from "@/lib/api";

export default function ProtectedRoute({ roles }) {
  const token = getToken();
  const user = getUser();
  const location = useLocation();

  if (!token || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={roleHome(user.role)} replace />;
  }
  return <Outlet />;
}
